module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/effects-9c0d6360438b1ea4474d92beb92da689.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/effects.svg
// module id = qFaF
// module chunks = 24